/* ─────────────────────────────────────────────────────────────────────────
   Customer testimonials — carousel nav for sections/customer-testimonials.liquid.
   Native CSS scroll-snap handles touch/drag; this only wires the optional
   prev/next arrows and dot pagination, and keeps dots in sync on scroll.
   ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.hasAttribute('data-testimonials-ready')) return;
    root.setAttribute('data-testimonials-ready', '');

    var track = root.querySelector('[data-testimonials-track]');
    var prevBtn = root.querySelector('[data-testimonials-prev]');
    var nextBtn = root.querySelector('[data-testimonials-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-testimonials-dot]'));
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || !cards.length) return;

    function cardStep() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function activeIndex() {
      var step = cardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function scrollToIndex(index) {
      var clamped = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: cardStep() * clamped, behavior: 'smooth' });
    }

    function updateDots() {
      var index = activeIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(activeIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(activeIndex() + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToIndex(parseInt(dot.getAttribute('data-index'), 10) || 0);
      });
    });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateDots, 100);
    }, { passive: true });

    updateDots();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-testimonials]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();